import apiInterceptor from '@/utils/apiInterceptor'

const API_CONFIG = {
  BASE_URL: process.env.VUE_APP_KSSO_URL || 'http://gateway.keco.vip',
  APP_ID: 'with_resume',
  APP_SECRET: 'with_resume'
}

function getCommonHeaders() {
  return {
    'req_app_id': API_CONFIG.APP_ID,
    'req_app_secret': API_CONFIG.APP_SECRET
  }
}

class ResumeService {
  /**
   * 获取简历列表
   * @param {Object} params 查询参数
   * @returns {Promise<Object>} 返回数据
   */
  async getResumeList(params = {}) {
    try {
      const url = `${API_CONFIG.BASE_URL}/api/resume/list`
      const response = await apiInterceptor.post(url, params, {
        headers: getCommonHeaders()
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('获取简历列表失败:', error)
      throw error
    }
  }

  /**
   * 更新简历状态
   * @param {number} id 简历ID
   * @param {string} status 新状态
   * @returns {Promise<Object>} 返回数据
   */
  async updateResumeStatus(id, status) {
    try {
      const url = `${API_CONFIG.BASE_URL}/api/resume/status`
      const requestData = {
        id: id,
        status: status
      }

      const response = await apiInterceptor.post(url, requestData, {
        headers: getCommonHeaders()
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('更新简历状态失败:', error)
      throw error
    }
  }
}

export default new ResumeService() 